export default {"src":"/_next/static/media/nosmoke.4b85e2a9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};